export class Skill {
  constructor () {
    this.id = null
    this.trainerId = ''
    this.skillId = ''
    this.skillName = ''
    // this.proficiency = ''
    this.seniority = ''
    this.workProfile = ''
    this.experienceYears = ''
    this.numberOfTrainings = ''
    this.subSkills = []
  }
}



// WEBPACK FOOTER //
// ./src/models/Skill.js